import { FixTag } from "./FixTag";
import { FixDictionary } from "./dictionary/FixDictionary";

export class FixMessage {
  private static nextId = 0;

  readonly id: number = FixMessage.nextId++;
  dialect: string | undefined = undefined;
  readonly source: string;
  private beginString: string | undefined = undefined;
  private bodyLength: number | undefined = undefined;
  private dictionary: FixDictionary | undefined = undefined;
  tags: FixTag[] = [];

  /**
   * @type {string}
   */
  private msgType: FixTag | undefined = undefined;
  conversation = null;
  // validation
  /**
   *
   * @type {boolean}
   */
  public valid = true;
  public visible = true;
  readonly errors: string[] = [];
  private normalizedSrc: string | undefined = undefined;
  senderCompId: string | undefined = undefined;
  senderSubId: string | undefined = undefined;
  targetCompId: string | undefined = undefined;
  targetSubId: string | undefined = undefined;

  public constructor(normalizedSource: string) {
    this.source = normalizedSource;
  }

  public addTag(tag: FixTag) {
    this.tags.push(tag);
  }

  public getFixSpec(): string | undefined {
    return this.beginString;
  }

  /**
   * @public
   * @param index
   * @return {FixTag}
   */
  public getTagByIndex(index: number): FixTag | null {
    if (index >= this.tags.length) return null;
    return this.tags[index];
  }

  public getMessageType(): string {
    if (this.msgType) {
      return this.msgType.getDescription();
    } else {
      return "Unknown";
    }
  }

  public isAdmin(): boolean {
    if (this.dictionary !== undefined && this.msgType?.value !== undefined) {
      return this.dictionary.isAdmin(this.msgType?.value);
    } else {
      return false;
    }
  }

  public isGroupStart(tag: FixTag) {
    // if (!!this.msgType) {
    // }
    return false;
  }

  normalizedSource(): string {
    if (!this.normalizedSrc) {
      let r = "";
      for (let i = 0; i < this.tags.length; i++) {
        r += this.tags[i].num + "=" + this.tags[i].value + "|";
      }
      this.normalizedSrc = r;
    }
    return this.normalizedSrc;
  }

  /**
   * @public
   */
  getFrom(): string {
    return (
      this.senderCompId + (!!this.senderSubId ? ":" + this.senderSubId : "")
    );
  }

  /**
   * @public
   */
  getTo() {
    return (
      this.targetCompId + (!!this.targetSubId ? ":" + this.targetSubId : "")
    );
  }
}
